import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

export default function BoxIcon(props) {
    return (
        <SvgIcon {...props} viewBox='0 0 16 17' fill='none'>
            <path d='M1 12.3846V5L8 1L15 5V12.3846L8 16.5L1 12.3846Z' fill='#FFDF00' />
            <path d='M1 5V12.3846L8 16.5L15 12.3846V5M1 5L8 9L15 5M1 5L8 1L15 5' stroke='black' strokeWidth='0.5' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M8 9V16.5' stroke='black' strokeWidth='0.5' strokeLinecap='round' strokeLinejoin='round' />
        </SvgIcon>
    );
}



// WEBPACK FOOTER //
// ./views/home/supervisor-home/expenditure-by-organization/assets/box-icon.js